import { Container, Row, Col } from 'react-bootstrap';
import Box from "../Home/Box.jsx"
import RegistrationsTopImage from "../../assets/Registrations/FluteCamp.jpeg"
import "./Registrations.css"

import DownloadFile from "../DownloadFile/DownloadFile.jsx"

export default function Registrations() {
  return (
    <div className="home-wrapper">
      <Container style={{ paddingLeft: "4vw", paddingRight: "4vw" }}>
        <Row>
          <Col>
            <Box title="Registrations" />
            <br />
            <Row>
              <center>
                <img className="contact-image" src={RegistrationsTopImage} alt="Register!" />
              </center>
            </Row>
          </Col>
        </Row>
        <br />
        <Row>
            <div className="registration-paragraph-top green">
              REGISTRATIONS-See Below
            </div>
            <div className="registration-paragraph-top" style={{ fontSize: "24px" }}>
              If you have any problems downloading, contact us at flutealliance@gmail.com
            </div>
        </Row>
        
        <br />
        <hr className="about-hr" />
        <Row>
          <p className="registration-paragraph">
            Flute Boot Camps <br />
            Join us for the 2024 Flute Boot Camp <br />
            July 8-12, 9:30-3:00 <br />
            The Rise Church (formerly Calvin Presbyterian) <br />
            Tigard, OR <br />
            See registration form below or on Home page <br />
          </p>
          <DownloadFile fileName="fbc2024-registration.pdf" fileUrl="./pdfs/fbc2024-registration.pdf" />
        </Row>
        
        <br />
      </Container>
    </div>
  );
}
